export enum BILoginType {

    Regular = "Regular",
    Social = "Social",
    Token = "Token",
    Biometric = "Biometric",
}
